/**
 * Multi-agent artifact constants.
 *
 * Type sets and colour maps for artifacts — used across ChatPanel
 * (which types render expanded), WorkspacePanel (which qualify as
 * "code" and get the diff badge), and ArtifactCard (validation /
 * risk colour coding).
 */

/**
 * Artifact types that are shown expanded by default when rendering
 * past conversation turns. All others default to collapsed so we
 * don't mount a Monaco editor for every evidence row.
 */
export const OPEN_ARTIFACT_TYPES = new Set([
  "code_patch",
  "diff",
  "apex_class",
  "apex_trigger",
  "visualforce_page",
  "lwc_bundle",
  "lwc_js",
  "lwc_html",
  "source",
  "code",
]);

/**
 * Artifact types treated as code / diff that surface the badge and
 * diff-editor in the Workspace panel.
 */
export const CODE_ARTIFACT_TYPES = new Set([
  "apex_class",
  "apex_trigger",
  "diff",
  "code_patch",
]);

/** Maps validation_status strings to CSS colour tokens. */
export const VALIDATION_COLOR: Record<string, string> = {
  unverified:      "var(--ma-text-muted)",
  compiles:        "var(--ma-state-warn)",
  runs_tests_pass: "var(--ma-state-ok)",
  runs_tests_fail: "var(--ma-state-err)",
};

/** Maps risk level strings to CSS colour tokens. */
export const RISK_COLOR: Record<string, string> = {
  low:    "var(--ma-state-ok)",
  medium: "var(--ma-state-warn)",
  high:   "var(--ma-state-err)",
};
